import React from 'react'
import { Link } from 'react-router-dom'
import { Menu } from 'antd'

import { Card, Layout } from 'admin/lib/Layouts'
import { Breadcrumb } from 'admin/lib/Breadcrumbs'
import * as ROUTES from 'admin/routes'

export function ReferenceDataIndex() {
  const items = [
    {
      label: (
        <Link to={ROUTES.REFERENCEITEMS.LIST}>Reference Product Items</Link>
      ),
      key: 'referenceProductItems'
    },
    {
      label: <Link to={ROUTES.CERTIFICATES.LIST}>Certificates</Link>,
      key: 'certificates'
    },
    {
      label: <Link to={ROUTES.COMPANIES.LIST}>Companies</Link>,
      key: 'companies'
    }
  ]

  return (
    <Layout
      header={
        <Breadcrumb
          items={[
            {
              title: 'Reference Data'
            }
          ]}
        />
      }
    >
      <Card>
        <Menu style={{ width: '100%', height: '100%' }} items={items} />
      </Card>
    </Layout>
  )
}
